module.exports = __webpack_public_path__ + "static/media/sidebar-bg.58666ce4.jpg";